export default "__VITE_ASSET__bc190191__"